import { createSelector } from "reselect";
import { getConfig } from "@jti/fe-common";
const getStoreConfig = (state) => { var _a; return (_a = state.cart) === null || _a === void 0 ? void 0 : _a.storeConfig; };
export const selectPostCodeConfig = createSelector([getStoreConfig], (storeConfig) => {
    const { HIDE_POST_CODE_INPUT, postCodeKeyboardType } = getConfig();
    const validationEnabled = storeConfig === null || storeConfig === void 0 ? void 0 : storeConfig.postcode_validation_enabled;
    const isRequired = storeConfig === null || storeConfig === void 0 ? void 0 : storeConfig.postcode_is_required;
    const shouldHidePostCode = /true/i.test(HIDE_POST_CODE_INPUT) && validationEnabled && !isRequired;
    return {
        postcode_is_required: isRequired,
        postcode_max_length: storeConfig === null || storeConfig === void 0 ? void 0 : storeConfig.postcode_max_length,
        postcode_min_length: storeConfig === null || storeConfig === void 0 ? void 0 : storeConfig.postcode_min_length,
        postcode_validate_regex: storeConfig === null || storeConfig === void 0 ? void 0 : storeConfig.postcode_validate_regex,
        postcode_validation_enabled: validationEnabled,
        shouldHidePostCode: shouldHidePostCode,
        postCodeKeyboardType: postCodeKeyboardType !== null && postCodeKeyboardType !== void 0 ? postCodeKeyboardType : "default",
    };
});
//# sourceMappingURL=selectPostCodeConfig.js.map